<nz-card [nzLoading]="isAccountInfoLoading">
  <h2>{{ 'ACCOUNT_SETTINGS.ACCOUNT_INFO.TITLE' | translate }}</h2>

  <nz-card nzType="inner" [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT_INFO.COMPANY_SECTION' | translate)">
    <nz-descriptions nzBordered [nzColumn]="1" size="middle">
      <nz-descriptions-item [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT_INFO.COMPANY_NAME' | translate)">
        {{ company?.name || ('ACCOUNT_SETTINGS.ACCOUNT_INFO.NOT_AVAILABLE' | translate) }}
      </nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT_INFO.COMPANY_EMAIL' | translate)">
        {{ company?.email || ('ACCOUNT_SETTINGS.ACCOUNT_INFO.NOT_AVAILABLE' | translate) }}
      </nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT.EMAIL_LABEL' | translate)">
        {{ email || ('ACCOUNT_SETTINGS.ACCOUNT_INFO.NOT_AVAILABLE' | translate) }}
      </nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT.DISPLAY_NAME_LABEL' | translate)">
        {{ displayName || ('ACCOUNT_SETTINGS.ACCOUNT_INFO.NOT_AVAILABLE' | translate) }}
      </nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT.ROLE_LABEL' | translate)">
        <div>
          <strong>{{ roleLabelKey | translate }}</strong>
          <div>{{ roleDescription }}</div>
          <a href="javascript:void(0)" (click)="showRoleCapabilities = !showRoleCapabilities">
            {{ (showRoleCapabilities ? 'COMMON.SHOW_LESS' : 'COMMON.SHOW_MORE') | translate }}
          </a>
          <div *ngIf="showRoleCapabilities">
            <strong>{{ 'TEAM_ACCESS.CAN_DO' | translate }}</strong>
            <ul>
              <li *ngFor="let item of roleCanLabels">{{ item }}</li>
            </ul>
            <strong *ngIf="roleCannotLabels.length">{{ 'TEAM_ACCESS.CANNOT_DO' | translate }}</strong>
            <ul *ngIf="roleCannotLabels.length">
              <li *ngFor="let item of roleCannotLabels">{{ item }}</li>
            </ul>
          </div>
        </div>
      </nz-descriptions-item>
<!--      <nz-descriptions-item [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT_INFO.COMPANY_DOMAIN' | translate)">-->
<!--        {{ company?.domain || ('ACCOUNT_SETTINGS.ACCOUNT_INFO.NOT_AVAILABLE' | translate) }}-->
<!--      </nz-descriptions-item>-->
    </nz-descriptions>
  </nz-card>

  <nz-card nzType="inner" [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT_INFO.IDENTIFIERS_SECTION' | translate)" class="identifiers-card">
    <nz-descriptions nzBordered [nzColumn]="1" size="middle">
      <nz-descriptions-item [nzTitle]="'ACCOUNT_SETTINGS.ACCOUNT_INFO.PLAN' | translate">
        {{ planTranslationKey | translate }}
      </nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT_INFO.CUSTOMER_NUMBER' | translate)">
        {{ identifiers.companyCustomerNumber || ('ACCOUNT_SETTINGS.ACCOUNT_INFO.NOT_AVAILABLE' | translate) }}
      </nz-descriptions-item>

      <ng-container *ngIf="hasContract">
<!--        <nz-descriptions-item [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT_INFO.CONTRACT_NUMBER' | translate)">-->
<!--          {{ identifiers.contractNumber }}-->
<!--        </nz-descriptions-item>-->
        <nz-descriptions-item [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT_INFO.CONTRACT_START_DATE' | translate)">
          {{ identifiers.contractStartDate ? (identifiers.contractStartDate | date:'yyyy-MM-dd') : ('ACCOUNT_SETTINGS.ACCOUNT_INFO.NOT_AVAILABLE' | translate) }}
        </nz-descriptions-item>
<!--        <nz-descriptions-item [nzTitle]="('ACCOUNT_SETTINGS.ACCOUNT_INFO.CONTRACT_END_DATE' | translate)">-->
<!--          {{ identifiers.contractEndDate ? (identifiers.contractEndDate | date:'yyyy-MM-dd') : ('ACCOUNT_SETTINGS.ACCOUNT_INFO.NOT_AVAILABLE' | translate) }}-->
<!--        </nz-descriptions-item>-->
      </ng-container>
    </nz-descriptions>
  </nz-card>
</nz-card>
